module.exports = __webpack_public_path__ + "static/media/16_digginglight.4db510cd.jpg";